import { getColumnRawValue } from "./monthGrouping";

/**
 * Grouping by a currency column. Each row holds its own amount, so grouping on the raw
 * value gives one group per figure; a column that opts in through
 * `meta.currencyGroupCode` groups on the currency its amount is in instead — the code
 * the field is configured with, or the row's own code where the currency varies by row.
 */

export type CurrencyGroupCode = (row: unknown) => string | null | undefined;

export const getCurrencyGroupCode = (
  meta: unknown
): CurrencyGroupCode | undefined => {
  const groupCode = (meta as { currencyGroupCode?: unknown } | undefined)
    ?.currencyGroupCode;
  return typeof groupCode === "function"
    ? (groupCode as CurrencyGroupCode)
    : undefined;
};

/** The currency code a row's amount is in, or "" when the row holds no amount. */
export const columnCurrencyGroupKey = (column: unknown, row: unknown): string => {
  const groupCode = getCurrencyGroupCode(
    (column as { meta?: unknown } | undefined)?.meta
  );
  const amount = getColumnRawValue(column, row);
  if (!groupCode || amount === null || amount === undefined || amount === "")
    return "";
  return groupCode(row) ?? "";
};

/**
 * Keeps every currency group in the order its first row arrived and puts rows with no
 * amount last.
 */
export const currencyGroupRank =
  (column: unknown) =>
  (row: unknown): number | null =>
    columnCurrencyGroupKey(column, row) ? 0 : null;
